import React, {Component} from 'react';
import {Container, Header} from "semantic-ui-react";
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {getLocalization} from '../utils/localization';
import {faWarning} from '@fortawesome/free-solid-svg-icons'
import Footer from './footer';
import {connect} from "react-redux";
import {CustomGrid} from './custom-common';

const mapStateToProps = (state, ownProps) => {
    const {user} = state;
    return {
        lang: user.lang,
        ...ownProps
    }
};

class EnrollmentIssue extends Component {
    componentDidMount() {
        window.onbeforeunload = null;
    }

    render() {
        const {lang} = this.props;
        const localization = getLocalization(lang);
        const strings = localization.enrollmentProblem;

        return (
            <div className="member-main-container">
                <Container fluid className={"employer-accountCreation-container"}>
                    <CustomGrid columns={1} style={{marginTop: '5%'}}>
                        <CustomGrid.Column textAlign="center">
                            <FontAwesomeIcon icon={faWarning} className={'enrollmentIssueIcon'}/>
                            <Header as='h5' className='neutral900Text'>
                                {strings.enrollmentIssue}
                            </Header>
                            <span style={{whiteSpace: 'pre-line'}}>{strings.unableToRetrieve}</span>
                        </CustomGrid.Column>
                    </CustomGrid>
                </Container>
                <Footer showTopFooter={false} showCenterData={true} hideLimitationsAndExclusions={true}/>
            </div>
        )
    }
}

export default connect(mapStateToProps)(EnrollmentIssue);
